// Diagrams Agent — action types + creators.
//
// Two-phase flow:
//   Phase A (interpret):  user submits topic + optional repo picks →
//                         BE proposes a scope → ticket = AWAITING_CONFIRMATION.
//   Phase B (render):     user confirms proposed scope → BE renders 3 PDFs.
//
// Both phases share the same runId — the FE polls a single DIAGRAMSTICKET row.

export const TRIGGER_DIAGRAMS_INTERPRET_REQUEST = "TRIGGER_DIAGRAMS_INTERPRET_REQUEST";
export const TRIGGER_DIAGRAMS_INTERPRET_SUCCESS = "TRIGGER_DIAGRAMS_INTERPRET_SUCCESS";
export const TRIGGER_DIAGRAMS_INTERPRET_FAILURE = "TRIGGER_DIAGRAMS_INTERPRET_FAILURE";

export const TRIGGER_DIAGRAMS_RENDER_REQUEST = "TRIGGER_DIAGRAMS_RENDER_REQUEST";
export const TRIGGER_DIAGRAMS_RENDER_SUCCESS = "TRIGGER_DIAGRAMS_RENDER_SUCCESS";
export const TRIGGER_DIAGRAMS_RENDER_FAILURE = "TRIGGER_DIAGRAMS_RENDER_FAILURE";

export const RESET_DIAGRAMS_STATE = "RESET_DIAGRAMS_STATE";

export const triggerDiagramsInterpretRequest = (payload) => ({
  type: TRIGGER_DIAGRAMS_INTERPRET_REQUEST,
  payload,
});
export const triggerDiagramsInterpretSuccess = (result) => ({
  type: TRIGGER_DIAGRAMS_INTERPRET_SUCCESS,
  payload: result,
});
export const triggerDiagramsInterpretFailure = (error) => ({
  type: TRIGGER_DIAGRAMS_INTERPRET_FAILURE,
  error,
});

export const triggerDiagramsRenderRequest = (payload) => ({
  type: TRIGGER_DIAGRAMS_RENDER_REQUEST,
  payload,
});
export const triggerDiagramsRenderSuccess = (result) => ({
  type: TRIGGER_DIAGRAMS_RENDER_SUCCESS,
  payload: result,
});
export const triggerDiagramsRenderFailure = (error) => ({
  type: TRIGGER_DIAGRAMS_RENDER_FAILURE,
  error,
});

export const resetDiagramsState = () => ({ type: RESET_DIAGRAMS_STATE });
